// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact__DRYFE","contactItem":"contact_contactItem__1U8oi"};